import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Map from "@babel/runtime-corejs2/core-js/map";
export var Colors;

(function (Colors) {
  Colors["RED_PINK"] = "#ff373c";
  Colors["RED"] = "#ec0000";
  Colors["ORANGE"] = "#ff8228";
  Colors["LIGHT_ORANGE"] = "#ffb432";
  Colors["LIGHT_BLUE"] = "#d2f0ff";
  Colors["GREY"] = "#505050";
  Colors["LIGHT_GREY"] = "#535353";
  Colors["BLUE"] = "#3f75c6";
  Colors["GREEN"] = "#008906";
  Colors["LIGHT_GREEN"] = "#a5bb48";
  Colors["PURPLE"] = "#c34789";
  Colors["GREY4"] = "#f8f8f8";
  Colors["GREY8"] = "#f1f1f1";
  Colors["GREY16"] = "#e3e3e3";
  Colors["GREY24"] = "#d5d5d5";
  Colors["GREY48"] = "#ababab";
  Colors["GREY80"] = "#737373";
  Colors["GREY56"] = "#232323";
  Colors["WHITE"] = "white";
  Colors["BLACK"] = "black";
  Colors["TRANSPARENT"] = "transparent";
})(Colors || (Colors = {}));

var colorHexMap = new _Map([[Colors.RED_PINK, 'redPink'], [Colors.RED, 'red'], [Colors.ORANGE, 'orange'], [Colors.LIGHT_ORANGE, 'lightOrange'], [Colors.LIGHT_BLUE, 'lightBlue'], [Colors.GREY, 'grey'], [Colors.LIGHT_GREY, 'lightGrey'], [Colors.BLUE, 'blue'], [Colors.GREEN, 'green'], [Colors.LIGHT_GREEN, 'lightGreen'], [Colors.PURPLE, 'purple'], [Colors.GREY4, 'grey4'], [Colors.GREY8, 'grey8'], [Colors.GREY16, 'grey16'], [Colors.GREY24, 'grey24'], [Colors.GREY48, 'grey48'], [Colors.GREY80, 'grey80'], [Colors.GREY56, 'grey56'], [Colors.WHITE, 'white'], [Colors.BLACK, 'black'], [Colors.TRANSPARENT, 'transparent']]);
/*
 Returns camel case string, the enum key and the hex value of each color in an
 object.
 */

export var ColorObjsArray = getColorObjsArray();
/**
 * Returns the array of color names in camelCase.
 */

export var ColorsArray = getColorsArray();

function getColorObjsArray() {
  return _Object$keys(Colors).map(function (key) {
    return {
      colorKey: key,
      colorValue: Colors[key],
      colorString: colorHexMap.get(Colors[key])
    };
  });
}
/**
 *
 */


function getColorsArray() {
  return getColorObjsArray().map(function (_ref) {
    var colorString = _ref.colorString;
    return colorString;
  });
}